import {
	queryOptions,
	useMutation,
	useQuery,
	useQueryClient,
} from "@tanstack/react-query"
import { userKeys } from "@/entities/user"
import { subscriptionKeys } from "../model/keys"
import { cancelSubscription, getSubscriptionStatus } from "./client"

export function subscriptionStatusQueryOptions() {
	return queryOptions({
		queryKey: subscriptionKeys.status(),
		queryFn: getSubscriptionStatus,
		staleTime: 60_000, // 1 minute
	})
}

/**
 * Хук для получения статуса подписки
 */
export function useSubscriptionStatus() {
	return useQuery(subscriptionStatusQueryOptions())
}

/**
 * Хук для отмены подписки
 */
export function useCancelSubscription() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: cancelSubscription,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: subscriptionKeys.all })
			queryClient.invalidateQueries({ queryKey: userKeys.all })
		},
	})
}
